"use client";

import { Modal } from "@/components/modal";
import dynamic from "next/dynamic";
import type { SpreadChartOverlay } from "@/components/price-chart";

const PriceChart = dynamic(() => import("@/components/price-chart"), { ssr: false });

/**
 * Shared price-chart modal. Open when `symbol` is non-null; renders the price
 * chart at a fixed large size. Used everywhere a chart icon opens a chart.
 */
export function ChartModal({
  symbol,
  spreadOverlay,
  focusDate,
  focusLevel,
  onClose,
  height = "75vh",
  zIndex,
  defaultTimeframe,
  accountHash,
}: {
  symbol: string | null;
  spreadOverlay?: SpreadChartOverlay | null;
  focusDate?: string | null;
  focusLevel?: number | null;
  onClose: () => void;
  height?: string;
  zIndex?: number;
  defaultTimeframe?: "1D" | "5m";
  accountHash?: string | null;
}) {
  return (
    <Modal open={!!symbol} onClose={onClose} width="90vw" maxWidth="1200px" maxHeight="90vh" zIndex={zIndex}>
      {symbol && (
        <div className="flex flex-col" style={{ height, width: "100%" }}>
          <PriceChart symbol={symbol} spreadOverlay={spreadOverlay ?? null} focusDate={focusDate ?? null} focusLevel={focusLevel ?? null} onClose={onClose} className="flex-1 min-h-0" defaultTimeframe={defaultTimeframe} accountHash={accountHash} />
        </div>
      )}
    </Modal>
  );
}
